export default __webpack_public_path__ + "static/media/yellow-3.c88bf5cf.png";